import { connect } from 'react-redux';
import React, { Component } from 'react';
import { Common } from 'ws-scripts/modules/common';
import PropTypes from 'prop-types';

import Comments from '../components/Comments';

class WidgetContainer extends Component {
	render() {
		return (
			<Common
				render={() => {
					const { comments } = this.props;
					return comments && <Comments {...{ comments }} />;
				}}
			/>
		);
	}
}

WidgetContainer.propTypes = {
	comments: PropTypes.string.isRequired
};

const mapStateToProps = (_state) => {
	return {
		comments: _state.comments
	};
};

const Widget = connect(mapStateToProps)(WidgetContainer);

export default Widget;
